// src/pages/inadmin/AdminUserPermissionsPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminUserPermissionsPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [users, setUsers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ user_id: '', permission_id: '' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserPermissions();
    fetchUsers();
    fetchPermissions();
  }, []);

  const fetchUserPermissions = () => {
    axios
      .get('/inadmin/user_permissions')
      .then((response) => setUserPermissions(response.data))
      .catch((error) =>
        console.error('Error al obtener relaciones user_permissions:', error)
      );
  };

  const fetchUsers = () => {
    axios
      .get('/inadmin/users')
      .then((response) => setUsers(response.data))
      .catch((error) => console.error('Error al obtener usuarios:', error));
  };

  const fetchPermissions = () => {
    axios
      .get('/inadmin/permissions')
      .then((response) => setPermissions(response.data))
      .catch((error) => console.error('Error al obtener permisos:', error));
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setFormData({ user_id: '', permission_id: '' });
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    axios
      .post('/inadmin/user_permissions', formData)
      .then(() => {
        fetchUserPermissions();
        handleClose();
      })
      .catch((error) =>
        console.error('Error al crear relación user_permission:', error)
      );
  };

  const handleEdit = (id) => {
    navigate(`/inadmin/user_permissions/edit/${id}`);
  };

  const handleDelete = (id) => {
    axios
      .delete(`/inadmin/user_permissions/${id}`)
      .then(() => fetchUserPermissions())
      .catch((error) =>
        console.error('Error al eliminar relación user_permission:', error)
      );
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <h2>Gestión de Relaciones Usuario-Permiso</h2>
        <Button variant="contained" color="primary" onClick={handleOpen}>
          Crear Relación
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell><strong>User ID</strong></TableCell>
              <TableCell><strong>Permission ID</strong></TableCell>
              <TableCell><strong>Acciones</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userPermissions.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.user_id}</TableCell>
                <TableCell>{row.permission_id}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleEdit(row.id)}
                    sx={{ mr: 1 }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleDelete(row.id)}
                  >
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {userPermissions.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No hay relaciones registradas.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog para Crear Relación */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Crear Nueva Relación Usuario-Permiso</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="dense" variant="standard">
            <InputLabel>User ID</InputLabel>
            <Select
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              label="User ID"
            >
              {users.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  {user.id} - {user.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense" variant="standard">
            <InputLabel>Permission ID</InputLabel>
            <Select
              name="permission_id"
              value={formData.permission_id}
              onChange={handleChange}
              label="Permission ID"
            >
              {permissions.map((perm) => (
                <MenuItem key={perm.id} value={perm.id}>
                  {perm.id} - {perm.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSubmit}>Crear</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminUserPermissionsPage;
